// extracted by mini-css-extract-plugin
export default {"container":"IA-z","heading":"JA-z","text":"KA-z","info":"LA-z","link":"MA-z","fullMaxWidth":"NA-z"};